import {
  SHOW_EXPIRATION_WARNING,
  HIDE_EXPIRATION_WARNING,
  RENEW_TOKEN,
  RENEW_TOKEN_SUCCESS,
  RENEW_TOKEN_FAILURE,
  START_EXPIRATION_MONITORING,
  STOP_EXPIRATION_MONITORING,
  CHECK_TOKEN_EXPIRATION,
  DISMISS_WARNING
} from './actions';

const initialState = {
  showWarning: false,
  timeRemaining: null,
  expiresAt: null,
  isRenewing: false,
  renewalError: null,
  isMonitoring: false,
  lastChecked: null
};

const tokenExpirationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_EXPIRATION_WARNING:
      return {
        ...state,
        showWarning: true,
        timeRemaining: action.payload.timeRemaining,
        expiresAt: action.payload.expiresAt,
        renewalError: null
      };

    case HIDE_EXPIRATION_WARNING:
      return {
        ...state,
        showWarning: false,
        timeRemaining: null,
        expiresAt: null,
        isRenewing: false,
        renewalError: null
      };

    case RENEW_TOKEN:
      return {
        ...state,
        isRenewing: true,
        renewalError: null
      };

    case RENEW_TOKEN_SUCCESS:
      return {
        ...state,
        isRenewing: false,
        showWarning: false,
        timeRemaining: null,
        expiresAt: action.payload.newExpiresAt,
        renewalError: null
      };

    case RENEW_TOKEN_FAILURE:
      return {
        ...state,
        isRenewing: false,
        renewalError: action.payload.error
      };

    case START_EXPIRATION_MONITORING:
      return {
        ...state,
        isMonitoring: true
      };

    case STOP_EXPIRATION_MONITORING:
      return {
        ...state,
        isMonitoring: false
      };

    case CHECK_TOKEN_EXPIRATION:
      return {
        ...state,
        lastChecked: new Date().toISOString()
      };

    case DISMISS_WARNING:
      return {
        ...state,
        showWarning: false,
        timeRemaining: null,
        expiresAt: null
      };

    default:
      return state;
  }
};

export default tokenExpirationReducer;
